import { formatRelativeTimeLang as formatTimeWithLang } from './i18n.js'

export function formatRelativeTimeLang(dateInput, lang = 'en') {
  return formatTimeWithLang(dateInput, lang)
}

const NAMED_ENTITIES = {
  amp: '&',
  lt: '<',
  gt: '>',
  quot: '"',
  apos: "'",
  nbsp: ' ',
  ndash: '–',
  mdash: '—',
  lsquo: '‘',
  rsquo: '’',
  sbquo: '‚',
  ldquo: '“',
  rdquo: '”',
  bdquo: '„',
  hellip: '…',
  euro: '€',
  pound: '£',
  copy: '©',
  reg: '®',
  trade: '™'
}

/**
 * Avkodar HTML-entiteter som &#039;, &#8217;, &amp;, &ndash; samt rensar CDATA och HTML-taggar
 */
export function cleanTitle(rawTitle) {
  if (!rawTitle) return ''
  return rawTitle
    .replace(/<!\[CDATA\[(.*?)\]\]>/gs, '$1')
    .replace(/<[^>]+>/g, '')
    // Hex-entiteter (t.ex. &#x27;)
    .replace(/&#x([0-9a-fA-F]+);/g, (_, hex) => {
      try { return String.fromCodePoint(parseInt(hex, 16)) } catch { return '' }
    })
    // Decimala entiteter (t.ex. &#039;, &#39;, &#8217;)
    .replace(/&#(\d+);/g, (_, dec) => {
      try { return String.fromCodePoint(parseInt(dec, 10)) } catch { return '' }
    })
    // Namngivna entiteter (t.ex. &quot;, &ndash;, &amp;)
    .replace(/&([a-zA-Z]+);/g, (match, name) => NAMED_ENTITIES[name.toLowerCase()] || match)
    // Extra pass vid dubbelkodning som &amp;#039;
    .replace(/&#(\d+);/g, (_, dec) => {
      try { return String.fromCodePoint(parseInt(dec, 10)) } catch { return '' }
    })
    .replace(/\s+/g, ' ')
    .trim()
}
